module.exports = __webpack_public_path__ + "static/media/press_folha-pe.7b501a64.jpg";